/* global Swiper */

window.addEventListener( 'load', () => {

	document.querySelectorAll( '.b-cards-carousel' ).forEach( ( block ) => {

		const swiperElement = block.querySelector( '.swiper' );

		if ( !swiperElement ) {

			return;

		}

		block.querySelectorAll( '.b-cards-grid__card' ).forEach( ( card ) => {

			card.classList.add( 'swiper-slide' );

		} );

		new Swiper( swiperElement, {
			spaceBetween: 24,
			slidesPerView: 1,
			slideClass: 'b-cards-grid__card',
			loop: false,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
				addIcons: false,
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			breakpoints: {
				768: {
					slidesPerView: 2,
				},
				1366: {
					slidesPerView: 3,
					spaceBetween: 32,
				},
				1600: {
					slidesPerView: 4,
				},
			},
		} );

	} );

} );